(function () {
  if (window.__cpInit) return;
  window.__cpInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  var revealIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('cp-visible');
      revealIO.unobserve(e.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveal(root) {
    root.querySelectorAll('.cp-reveal').forEach(function (el) {
      if (el.dataset.cpR) return;
      el.dataset.cpR = '1';
      if (!revealIO || reduce) { el.classList.add('cp-visible'); return; }
      revealIO.observe(el);
    });
  }

  function contar(el) {
    var to = parseFloat(el.dataset.to);
    if (isNaN(to)) return;
    var dec = parseInt(el.dataset.dec || '0', 10);
    var pre = el.dataset.pre || '';
    var suf = el.dataset.suf || '';
    var miles = el.dataset.miles || ',';
    var decimal = el.dataset.decimal || '.';
    var dur = 1600;
    var t0 = null;
    function fmt(n) {
      var s = n.toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return pre + parts.join(decimal) + suf;
    }
    function paso(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(to * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  var countIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      contar(e.target);
      countIO.unobserve(e.target);
    });
  }, { threshold: 0.4 }) : null;

  function initCifras(root) {
    root.querySelectorAll('[data-cp-contar]').forEach(function (el) {
      if (el.dataset.cpInit) return;
      el.dataset.cpInit = '1';
      if (!countIO || reduce) return;
      countIO.observe(el);
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-cp-hs]').forEach(function (w) {
      if (w.dataset.cpInit) return;
      w.dataset.cpInit = '1';
      var puntos = w.querySelectorAll('[data-cp-punto]');
      var cards = w.querySelectorAll('[data-cp-card]');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('is-activo', i === j); p.setAttribute('aria-pressed', i === j ? 'true' : 'false'); });
        cards.forEach(function (c, j) { c.classList.toggle('is-activo', i === j); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); });
      cards.forEach(function (c, i) {
        c.addEventListener('mouseenter', function () { activar(i); });
        c.addEventListener('click', function () { activar(i); });
      });
      if (puntos.length || cards.length) activar(0);
    });
  }

  function initPasos(root) {
    root.querySelectorAll('[data-cp-pasos]').forEach(function (w) {
      if (w.dataset.cpInit) return;
      w.dataset.cpInit = '1';
      var tabs = w.querySelectorAll('[data-cp-tab]');
      var fotos = w.querySelectorAll('[data-cp-foto]');
      var segundos = parseFloat(w.dataset.auto || '0');
      var actual = 0;
      var timer = null;
      function activar(i, auto) {
        actual = i;
        tabs.forEach(function (t, j) {
          t.classList.toggle('is-activo', i === j);
          t.classList.remove('is-auto');
          t.setAttribute('aria-selected', i === j ? 'true' : 'false');
        });
        fotos.forEach(function (f, j) { f.classList.toggle('is-activo', i === j); });
        if (auto && tabs[i]) { void tabs[i].offsetWidth; tabs[i].classList.add('is-auto'); }
      }
      function parar() { if (timer) { clearInterval(timer); timer = null; } tabs.forEach(function (t) { t.classList.remove('is-auto'); }); }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { parar(); activar(i, false); }); });
      if (segundos > 0 && !reduce && tabs.length > 1) {
        w.style.setProperty('--cp-pasos-t', segundos + 's');
        activar(0, true);
        timer = setInterval(function () { activar((actual + 1) % tabs.length, true); }, segundos * 1000);
      } else {
        activar(0, false);
      }
    });
  }

  function formatoDinero(cents, formato) {
    var n = (cents || 0) / 100;
    formato = formato || '${{amount}}';
    function sep(num, dec, miles, decimal) {
      var s = num.toFixed(dec);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return p.length > 1 ? p[0] + decimal + p[1] : p[0];
    }
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, clave) {
      switch (clave) {
        case 'amount_no_decimals': return sep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(n, 2, "'", '.');
        default: return sep(n, 2, ',', '.');
      }
    });
  }

  function initProducto(root) {
    root.querySelectorAll('[data-cp-producto]').forEach(function (w) {
      if (w.dataset.cpInit) return;
      w.dataset.cpInit = '1';

      var principal = w.querySelector('[data-cp-principal]');
      var minis = w.querySelectorAll('[data-cp-mini]');
      function verFoto(src, id) {
        if (!principal || !src) return;
        principal.removeAttribute('srcset');
        principal.src = src;
        minis.forEach(function (m) { m.classList.toggle('is-activo', String(m.dataset.id) === String(id)); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { verFoto(m.dataset.src, m.dataset.id); }); });

      var qty = w.querySelector('input[name="quantity"]');
      var menos = w.querySelector('[data-cp-menos]');
      var mas = w.querySelector('[data-cp-mas]');
      if (qty && menos) menos.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (qty && mas) mas.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });

      var dataEl = w.querySelector('[data-cp-variantes]');
      if (!dataEl) return;
      var variantes = [];
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var radios = w.querySelectorAll('[data-cp-opcion]');
      if (!radios.length) return;
      var idInput = w.querySelector('[data-cp-id]');
      var precio = w.querySelector('[data-cp-precio]');
      var tachado = w.querySelector('[data-cp-tachado]');
      var boton = w.querySelector('[data-cp-boton]');
      var formato = w.dataset.moneda;

      function seleccion() {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[parseInt(r.dataset.cpOpcion, 10)] = r.value; });
        return sel;
      }
      function actualizar() {
        var sel = seleccion();
        var v = null;
        for (var i = 0; i < variantes.length; i++) {
          var ok = true;
          for (var k = 0; k < sel.length; k++) { if (variantes[i].options[k] !== sel[k]) { ok = false; break; } }
          if (ok) { v = variantes[i]; break; }
        }
        if (!v) {
          if (boton) { boton.disabled = true; boton.textContent = boton.dataset.agotado; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        if (tachado) {
          if (v.compare_at_price && v.compare_at_price > v.price) { tachado.hidden = false; tachado.textContent = formatoDinero(v.compare_at_price, formato); }
          else { tachado.hidden = true; }
        }
        if (boton) { boton.disabled = !v.available; boton.textContent = v.available ? boton.dataset.texto : boton.dataset.agotado; }
        if (v.featured_image && v.featured_image.src) {
          var src = v.featured_image.src;
          src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
          var mid = v.featured_media ? v.featured_media.id : null;
          verFoto(src, mid);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });
    });
  }

  function initTodo(root) {
    root = root && root.querySelectorAll ? root : document;
    initReveal(root);
    initCifras(root);
    initHotspots(root);
    initPasos(root);
    initProducto(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
